//Referência https://codepen.io/bbrady/pen/ozrjKE
import React, { Component } from 'react';


class GraficoCircular extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    getStarPercentage(){
        var p = this.props.starPercentage || 0;
        p = Math.min(p, 100);
        p = Math.max(p,0);
        return p;
    }

    getIndicatorPercentage(){
        var p = this.props.indicatorPercentage || 0;
        p = Math.min(p, 100);
        p = Math.max(p,0);
        return p;
    }

    render() {
        // Size of the enclosing square
        const sqSize = this.props.size || 200;
        const strokeWidth = (this.props.strokeWidth || 10);
        const percentage = Math.max(0, Math.min(100, this.props.percentage || 0)); //Limitando de 0 a 100
        // SVG centers the stroke width on the radius, subtract out so circle fits in square
        const radius = (sqSize - strokeWidth) / 2;
        // Enclose cicle in a circumscribing square
        const viewBox = `0 0 ${sqSize} ${sqSize}`;
        // Arc length at 100% coverage is the circle circumference
        const dashArray = radius * Math.PI * 2;
        // Scale 100% coverage overlay with the actual percent
        const dashOffset = dashArray - dashArray * percentage / 100;

        var style = {
            circleBackground: {
                stroke: "#ddd",
                fill: "none"
            },
            circleProgress: {
                fill: "none",
                stroke: this.props.color || "red",
                // strokeLinecap: "round",
                // strokeLinejoin: "round"
            },
            circleText: {
                fontSize: "18px",
                fontWeight: "bold",
                fill: "#505050"
            }
        }

        return (
            <div style={{width: sqSize, height: sqSize, position:"relative", display:"inline-block"}}>
                <svg
                    width={sqSize}
                    height={sqSize}
                    viewBox={viewBox}
                    style={{position:'relative'}}>
                    <circle
                        className="circle-background"
                        style={style.circleBackground}
                        cx={sqSize / 2}
                        cy={sqSize / 2}
                        r={radius}
                        strokeWidth={`${strokeWidth}px`} />
                    <circle
                        className="circle-progress"
                        cx={sqSize / 2}
                        cy={sqSize / 2}
                        r={radius}
                        strokeWidth={`${strokeWidth}px`}
                        // Start progress marker at 12 O'Clock
                        transform={`rotate(-90 ${sqSize / 2} ${sqSize / 2})`}
                        style={{
                            strokeDasharray: dashArray,
                            strokeDashoffset: dashOffset,
                            ...style.circleProgress
                        }} />
                    {/* <text
                        className="circle-text"
                        style={style.circleText}
                        x="50%"
                        y="50%"
                        dy=".3em"
                        textAnchor="middle">
                        {this.props.text}
                    </text> */}
                </svg>
                <div style={{
                    width: sqSize,
                    height: sqSize,
                    padding: strokeWidth + "px",
                    textAlign: "center",
                    position:"absolute",
                    top: 0,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    zIndex: "-1"
                }}>{this.props.content}</div>

                {/* Escola referencia (Estrela) */}
                {this.getStarPercentage() > 0 &&
                    <i className="fas fa-star" style={{
                        position:'absolute',
                        marginLeft: ((-strokeWidth/2)-1)+"px",
                        marginTop:((-strokeWidth/2)-1)+"px",
                        top: (sqSize/2 + Math.sin(-Math.PI/2 + (this.getStarPercentage()/100 * Math.PI * 2)) * (radius)) + "px",
                        left: (sqSize/2 + Math.cos(-Math.PI/2 + (this.getStarPercentage()/100 * Math.PI * 2))* (radius)) + "px",
                        color:"#EEBB11",
                        textShadow: "1px 1px 2px #505050",
                        fontSize: strokeWidth,
                    }}></i>
                }

                {/* Indicador da escola */}
                {this.getIndicatorPercentage() > 0 &&
                    <div style={{
                        position:'absolute',
                        marginLeft: "-2px",
                        marginTop:(-(strokeWidth+(strokeWidth/2))/2)+"px",
                        top: (sqSize/2 + Math.sin(-Math.PI/2 + (this.getIndicatorPercentage()/100 * Math.PI * 2)) * (radius)) + "px",
                        left: (sqSize/2 + Math.cos(-Math.PI/2 + (this.getIndicatorPercentage()/100 * Math.PI * 2))* (radius)) + "px",
                        color:"#EEBB11",
                        // boxShadow: "1px 1px 2px #505050",
                        height: (strokeWidth+(strokeWidth/2)) + 'px',
                        width:'4px',
                        backgroundColor:"#666666",
                        transform: `rotate(${(this.getIndicatorPercentage()/100 * Math.PI * 2)}rad)`// translate(-50%, -50%)`
                    }}></div>
                }
            </div>
        );
    }
}

export default GraficoCircular;
